import gql from 'graphql-tag'
import * as Fragments from './fragments'
import { BoGetUsersQuery, BoGetUsersQueryVariables } from '../../types/BoGetUsersQuery'

interface UserFilters {
  search: String
}

export const BO_GET_USERS_Q = gql<BoGetUsersQuery, BoGetUsersQueryVariables>`
  query BoGetUsersQuery(
    $page: Int
    $limit: Int
    $sort: String
    $domain: String
    $filters: UserFilters
  ) {
    users(page: $page, limit: $limit, sort: $sort, domain: $domain, filters: $filters) {
      count
      page
      values {
        ...BoUsersFragment
      }
    }
  }
  ${Fragments.BO_USERS_F}
`

/**
 * A user's personal content-grading usage against their allowance, served by
 * the analysis subgraph through the gateway. Used by the Feature Trial dialog
 * to show how much of a Content Grader trial has been consumed. `usageCount`
 * is the same per-user rolling-window count that gates grading — grades are
 * charged to the user who ran them, not to the account.
 */
export const CONTENT_GRADER_USER_USAGE_Q = gql`
  query ContentGraderUserUsage($userId: String!) {
    contentGraderUserUsage(userId: $userId) {
      usageCount
      maxRequests
      windowDays
    }
  }
`

export const LIST_PLAYER_CELLULAR_INFO_BY_EMAIL = gql`
  query ListPlayerCellularInfoByEmail($email: String!) {
    listPlayerCellularInfoByEmail(email: $email) {
      playerId
      shipmentDate
      simId
      controllerId
      carrier
      anydeskId
      anydeskPassword
      playerSubscriptionMapping {
        subscriptionId
      }
    }
  }
`
